import React from 'react';
import styled from "styled-components";
import {Grid} from "@mui/material";
import notAuthBackground from "../img/not-auth-background.png";

const NotAuthWrapper: React.FC<any> = ({children}) => {
    return (
        <StyledNotAuthContainer container direction="column">
            {children}
        </StyledNotAuthContainer>
    )
}

const StyledNotAuthContainer = styled(Grid)`
  width: 100%;
  min-height: 100vh;
  
  &:before {
    z-index: -1;
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background: url(${notAuthBackground}), lightgray 50% / cover no-repeat;
    mix-blend-mode: multiply;
  }
`;

export default NotAuthWrapper;